const state = {
  menuId: ''
};

const mutations = {
  setMenuId: (state, menuId) => {
    state.menuId = menuId;
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
